/* Verified RFQ success only. No page-view or click-based lead events. */
(function () {
  'use strict';
  if (window.StellTailsRfq) return;

  var pendingKey = 'st-rfq-pending-v1';
  var emitted = new Set();
  var nativeCompletions = new Map();
  var timeoutMs = 1200;

  function attemptId() {
    return window.crypto.randomUUID();
  }

  function waitForGtm() {
    if (typeof window.StellTailsLoadGtm === 'function') window.StellTailsLoadGtm();
    return new Promise(function (resolve) {
      var startedAt = Date.now();
      function check() {
        if (window.google_tag_manager && window.google_tag_manager['GTM-N392KL3D']) {
          resolve(true);
        } else if (Date.now() - startedAt >= 10000) {
          resolve(false);
        } else {
          window.setTimeout(check, 50);
        }
      }
      check();
    });
  }

  function emitSuccess(formType, formId, id) {
    if (emitted.has(id)) return Promise.resolve();
    emitted.add(id);
    return new Promise(function (resolve) {
      var timer = window.setTimeout(resolve, timeoutMs);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'rfq_success',
        form_type: formType,
        form_id: formId,
        submission_id: id,
        eventCallback: function () {
          window.clearTimeout(timer);
          resolve();
        },
        eventTimeout: timeoutMs
      });
    });
  }

  // Record an attempt, not a conversion. Only Liquid-confirmed success consumes it.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('form.st-commercial-rfq-form, form[data-st-rfq-track]')) return;
    if (!form.id || !form.checkValidity()) return;
    nativeCompletions.delete(form.id);
    try {
      // Shopify CAPTCHA can pause this event before completing the native POST.
      window.sessionStorage.setItem(pendingKey, JSON.stringify({
        id: attemptId(), formId: form.id, createdAt: Date.now()
      }));
    } catch (error) {
      // No reliable cross-navigation deduplication: fail closed, keep form working.
    }
  }, true);

  window.StellTailsRfq = {
    nativeSuccess: function (formId, target) {
      if (nativeCompletions.has(formId)) return nativeCompletions.get(formId);
      var pending;
      try {
        pending = JSON.parse(window.sessionStorage.getItem(pendingKey));
        if (pending && pending.formId !== formId) return Promise.resolve();
        if (pending) window.sessionStorage.removeItem(pendingKey);
      } catch (error) { pending = null; }
      var complete = Promise.resolve();
      if (pending && typeof pending.id === 'string' && pending.id.length > 0 &&
          typeof pending.createdAt === 'number' &&
          Date.now() - pending.createdAt >= 0 && Date.now() - pending.createdAt < 1800000) {
        complete = waitForGtm().then(function (ready) {
          if (ready) return emitSuccess('native_contact', formId, pending.id);
        });
      }
      complete = complete.catch(function () { /* Keep the success UI usable if analytics fails. */ })
        .then(function () { if (target) window.location.replace(target); });
      nativeCompletions.set(formId, complete);
      return complete;
    },
    nativeFailure: function (formId) {
      try {
        var pending = JSON.parse(window.sessionStorage.getItem(pendingKey));
        if (pending && pending.formId === formId) window.sessionStorage.removeItem(pendingKey);
      } catch (error) { /* Tracking must not interfere with form errors. */ }
    }
  };

  function readNativeResults() {
    document.querySelectorAll('[data-st-rfq-error]').forEach(function (result) {
      var form = result.closest('form');
      if (form) window.StellTailsRfq.nativeFailure(form.id);
    });
    document.querySelectorAll('[data-st-rfq-success]').forEach(function (result) {
      var form = result.closest('form');
      if (form) window.StellTailsRfq.nativeSuccess(form.id);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', readNativeResults, { once: true });
  } else {
    readNativeResults();
  }

  // Forms 1058786 has no public success DOM event in the inspected live bundle.
  // Observe only its actual submission response; preserve the response for the app.
  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var isRfq = false;
    try {
      var url = new URL(typeof input === 'string' ? input : input.url, window.location.href);
      if (url.origin === 'https://forms.shopifyapps.com' &&
          url.pathname === '/api/v2/form_submission' &&
          init && String(init.method).toUpperCase() === 'POST' && typeof init.body === 'string') {
        var body = JSON.parse(init.body);
        isRfq = String(body.form_instance_id) === '1058786' &&
          body.shopify_domain === window.Shopify.shop;
      }
    } catch (error) { /* Unrelated requests pass through unchanged. */ }
    if (isRfq && typeof window.StellTailsLoadGtm === 'function') window.StellTailsLoadGtm();
    var result = originalFetch.apply(this, arguments);
    if (!isRfq) return result;
    return result.then(async function (response) {
      try {
        // Observed on the real form on 2026-09-20. Unknown responses fail closed.
        if (response.status === 202 && /application\/json/i.test(response.headers.get('content-type') || '')) {
          var data = await response.clone().json();
          if (data.message === 'Company created successfully.' && data.errors &&
              typeof data.errors === 'object' && Object.keys(data.errors).length === 0) {
            var ready = await waitForGtm();
            if (ready) await emitSuccess('shopify_forms', '1058786', attemptId());
          }
        }
      } catch (error) { /* Tracking must never block a successful RFQ. */ }
      return response;
    });
  };
})();

